import { graphql } from "../graphql";
import query from "./query.gql";
import { RepoErrorEnum } from "../repo-error.enum";

export async function fetchOutletName(outletId: string): Promise<string> {
  try {
    const response = await graphql.query({
      query,
      variables: {
        outletId,
      },
    });

    return response.data.outlet.name;
  } catch {
    throw new Error(RepoErrorEnum.NETWORK_ERROR);
  }
}
